export default {
    data: () => ({
        translations: {
            title: {
                el: "Κείμενο SMS Απόκτησης Κουπονιού",
                en: "Coupon Claim SMS text",
                it: "Coupon Claim SMS testo"
            },
            smsRedemptionInfo: {
                el: "Εισάγετε το κείμενο που θέλετε να στέλνεται. Όπου θέλετε να συμπληρωθεί το όνομα της δωροεπιταγής εισάγετε <b>{voucher}</b>. Ενώ για τον κωδικό του voucher εισάγετε <b>{code}</b>.",
                en: `
                Enter the text you want to be sent. For the name of the voucher you can enter <b>{voucher}</b>. For the voucher code you can enter <b>{code}</b>.
                `,
                it: "Inserisca il testo che vuole inviare. Per il nome del buono può inserire <b>{voucher}</b>. Per il codice del buono puoi inserire <b>{code}</b>."
            },
            dynamicRewardSmsVariable: {
                el: "Σημειώνεται ότι ο αριθμός των χαρακτήρων και το κόστος ανά sms είναι μεταβλητά στην περίπτωση που χρησιμοποιείται το {voucher} ή το {code}. Ο κωδικός του κουπονιού {code} θα αποτελείται από τουλάχιστον 12 χαρακτήρες στο τελικό μήνυμα.",
                en: "Please note that the number of characters and the cost per sms is variable if {voucher} or {code} is used. The voucher code {code} will consist of at least 12 characters in the final message.",
                it: "Si noti che il numero di caratteri e il costo per sms variano se si utilizza {voucher} o {code}. Il codice del buono {code} sarà composto da almeno 12 caratteri nel messaggio finale."
            },
            message: {
                el: "Κείμενο",
                en: "Text",
                it: "Testo"
            },
            messageSenderEmail: {
                el: "",
                en: "Message Sender Email",
                it: ""
            },
            emailFirstMethod: {
                el: "",
                en: "Email (First method)",
                it: ""
            },
            verifyEmail: {
                el: "",
                en: "Verify Email",
                it: ""
            },
            emailFirstMethodInfo: {
                el: "",
                en:
                    "Add the email you want to see as the sender of the campaign",
                it: ""
            },
            emailSecondMethod: {
                el: "",
                en: "Email (Second method)",
                it: ""
            },
            emailSecondMethodInfo: {
                el: "",
                en: `
                    Enter your email credentials in the table below to send email campaigns
                    through your email provider. Leave this blank and RoadCube's email
                    provider will be used.
                `,
                it: ""
            },
            host: {
                el: "",
                en: "Host",
                it: ""
            },
            name: {
                el: "Όνομα",
                en: "Name",
                it: "Nome"
            },
            email: {
                el: "Email",
                en: "Email",
                it: "Email"
            },
            password: {
                el: "Κωδικός",
                en: "Password",
                it: "Codice"
            },
            info: {
                el: "",
                en: `
                    * Sending email by priority. If the first method doesnt exists then
                    the second method will be used. If the second method doesnt exists
                    as well then RoadCube's email provider will be used.
                `,
                it: ""
            }
        }
    })
};
